import routes from '@config/routes.json';

import { ActiveNavCandidate } from '../interfaces';

const isNavItemActive = ({ id, href }: ActiveNavCandidate, pathname: string): boolean => {
    if (!href) return false;

    if (id === 'faq') {
        return pathname.includes('/faq') && !pathname.includes(routes.faq.learning);
    }

    if (id === 'learning') {
        return pathname.includes(routes.faq.learning);
    }

    if (id === 'affiliatePrograms') {
        return pathname.includes(routes.offers);
    }

    if (id === 'trafficSources') {
        return pathname.includes(routes.placements.list);
    }

    if (id === 'support') {
        return pathname.includes('/support');
    }

    const normalizedHref = href.split('?')[0];

    return normalizedHref !== routes.home && pathname.includes(normalizedHref);
};

export default isNavItemActive;
